import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { UserActivityReportEntity } from './user-activity-report.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum UserActivityReportActionTypes {
  LoadUserActivityReports = '[UserActivityReport] Load UserActivityReports',
  AddUserActivityReport = '[UserActivityReport] Add UserActivityReport',
  UpsertUserActivityReport = '[UserActivityReport] Upsert UserActivityReport',
  AddUserActivityReports = '[UserActivityReport] Add UserActivityReports',
  UpsertUserActivityReports = '[UserActivityReport] Upsert UserActivityReports',
  UpdateUserActivityReport = '[UserActivityReport] Update UserActivityReport',
  UpdateUserActivityReports = '[UserActivityReport] Update UserActivityReports',
  DeleteUserActivityReport = '[UserActivityReport] Delete UserActivityReport',
  DeleteUserActivityReports = '[UserActivityReport] Delete UserActivityReports',
  ClearUserActivityReports = '[UserActivityReport] Clear UserActivityReports',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class LoadUserActivityReports implements Action {
  public readonly type = UserActivityReportActionTypes.LoadUserActivityReports;

  constructor(public payload: { userActivityReports: UserActivityReportEntity[] }) {}
}

export class AddUserActivityReport implements Action {
  public readonly type = UserActivityReportActionTypes.AddUserActivityReport;

  constructor(public payload: { userActivityReport: UserActivityReportEntity }) {}
}

export class UpsertUserActivityReport implements Action {
  public readonly type = UserActivityReportActionTypes.UpsertUserActivityReport;

  constructor(public payload: { userActivityReport: UserActivityReportEntity }) {}
}

export class AddUserActivityReports implements Action {
  public readonly type = UserActivityReportActionTypes.AddUserActivityReports;

  constructor(public payload: { userActivityReports: UserActivityReportEntity[] }) {}
}

export class UpsertUserActivityReports implements Action {
  public readonly type = UserActivityReportActionTypes.UpsertUserActivityReports;

  constructor(public payload: { userActivityReports: UserActivityReportEntity[] }) {}
}

export class UpdateUserActivityReport implements Action {
  public readonly type = UserActivityReportActionTypes.UpdateUserActivityReport;

  constructor(public payload: { userActivityReport: Update<UserActivityReportEntity> }) {}
}

export class UpdateUserActivityReports implements Action {
  public readonly type = UserActivityReportActionTypes.UpdateUserActivityReports;

  constructor(public payload: { userActivityReports: Update<UserActivityReportEntity>[] }) {}
}

export class DeleteUserActivityReport implements Action {
  public readonly type = UserActivityReportActionTypes.DeleteUserActivityReport;

  constructor(public payload: { id: string }) {}
}

export class DeleteUserActivityReports implements Action {
  public readonly type = UserActivityReportActionTypes.DeleteUserActivityReports;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearUserActivityReports implements Action {
  public readonly type = UserActivityReportActionTypes.ClearUserActivityReports;
}

export type UserActivityReportActions =
  | LoadUserActivityReports
  | AddUserActivityReport
  | UpsertUserActivityReport
  | AddUserActivityReports
  | UpsertUserActivityReports
  | UpdateUserActivityReport
  | UpdateUserActivityReports
  | DeleteUserActivityReport
  | DeleteUserActivityReports
  | ClearUserActivityReports;
